export const enum FormType {
  Legacy = 'legacy',
  NewTariffLine = 'newTariffLine',
  Order = 'order',
}
